import React from 'react';
import ClientReport from './ClientReport';
import ClientRouteTemplate from './ClientRouteTemplate';

const ClientReportRoute = (props) => (
  <ClientRouteTemplate 
    {...props}
    Component={ClientReport}
    componentName="Rapport"
  />
);

export default ClientReportRoute;
